import { useTranslation } from 'react-i18next';
import classes from './List.module.scss';

const list = [
    {
        subtitle: 'mechanical.list.li_01.subtitle',
        desc: 'mechanical.list.li_01.desc',
    },
    {
        subtitle: 'mechanical.list.li_02.subtitle',
        desc: 'mechanical.list.li_02.desc',
    },
    {
        subtitle: 'mechanical.list.li_03.subtitle',
        desc: 'mechanical.list.li_03.desc',
    },
    {
        subtitle: 'mechanical.list.li_04.subtitle',
        desc: 'mechanical.list.li_04.desc',
    },
    {
        subtitle: 'mechanical.list.li_05.subtitle',
        desc: 'mechanical.list.li_05.desc',
    },
];

const List = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <h2 className={`${classes.title} font-48`}>
                    {t('mechanical.list.title')}
                </h2>
                <ul className={`${classes.list} font-16`}>
                    {list.map((li, index) =>
                        <li key={index}>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t(li.subtitle)}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t(li.desc)}
                            </p>
                        </li>
                    )}
                </ul>
            </div>
        </section>
    );
};

export default List;
